{
  "steplist": "Список шагов"
}
